import {Injectable, Inject} from 'ng-metadata/core';


@Injectable()
export class RestUtils{

	constructor(@Inject('$http') private $http : angular.IHttpService) {

	}

	public postToServlet(url, data) {
		let config = {
			headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'},
			transformRequest: (obj) => {
				let parts =  Object.keys(obj)
					.map((p) => {
						return encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]);
					});

				return parts.join('&');
			}

		};
		return this.$http.post(url, data, config);
	}

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/restUtils.service.ts